import _ from 'lodash';
import React, { forwardRef, useRef } from 'react';
import DatePicker from 'react-datepicker';
import { FiChevronDown, FiSearch } from 'react-icons/fi';
import { CircleSpinner } from 'react-spinners-kit';
import styled from 'styled-components';
import { CalendarSvg } from '../../../assets/svg-icon-components/CalendarSvg';
import { ClockSvg } from '../../../assets/svg-icon-components/ClockSvg';
import { TrashSvg } from '../../../assets/svg-icon-components/TrashSvg';
import { useUserRoles } from '../../../util/use-user-role';
import { DashboardHeader } from '../../core/DashboardHeader';
import { DashboardWrapper } from '../../core/DashboardWrapper';
import { HorizontalContent } from '../../core/HorizontalContent';
import { Can } from '../../core/rbac/Can';
import { RhButton, RhButtonMode } from '../../core/RhButton';
import { RhCard } from '../../core/RhCard';
import { RhCardListItem } from '../../core/RhCardListItem';
import { RhImage } from '../../core/RhImage';
import { RhInput, RhInputMode } from '../../core/RhInput';
import { RhModal } from '../../core/RhModal';
import { RhTextArea } from '../../core/RhTextArea';
import { SizedBox } from '../../core/SizedBox';
import { colors, H2, H3 } from '../../core/Styles';
import { CommunicationsProps } from '../containers/CommunicationsContainer';

export const CommunicationsScreen: React.FC<CommunicationsProps> = props => {
  const { roles } = useUserRoles();
  const imageRef = useRef<HTMLInputElement>(null);

  return (
    <DashboardWrapper>
      <DashboardHeader title="Announcements" />
      <Grid>
        <div>
          <RhCard>
            <HorizontalContent
              left={<H2>Scheduled Notifications</H2>}
              right={[
                // <RhInput key="search-notifications-input" icon={FiSearch} placeholder="Search" />,
                props.isLoading && <CircleSpinner key="spinner" size={15} color={colors.primary} />,
                <Can
                  key="add-button"
                  perform="create:notifications"
                  role={roles?.[0]}
                  yes={<RhButton title="New Notification" onClick={props.userToggledFormModal} />}
                />,
              ]}
            />
            <NotificationList>
              {_.isEmpty(props.scheduledNotifications) ? (
                <div>No scheduled notifications</div>
              ) : (
                props.scheduledNotifications.map((notification, index) => (
                  <RhCardListItem
                    key={notification.id}
                    title={notification.title}
                    description={notification.content || ''}
                    startTime={notification.notifyDateTime.toString()}
                    isThumbnailDisabled={true}
                    topRightActions={[
                      <Can
                        key="delete"
                        role={roles?.[0]}
                        perform="delete:notifications"
                        yes={
                          <RhButton
                            mode={RhButtonMode.subtle}
                            prefixSvg={TrashSvg}
                            iconColor={colors.grey}
                            disabled={props.indexBeingDeleted === index}
                            onClick={() => {
                              props.userClickedDeleteOnACard({
                                id: notification.id,
                                type: 'schedule',
                                index,
                              });
                            }}
                          />
                        }
                      />,
                    ]}
                  />
                ))
              )}
            </NotificationList>
          </RhCard>
        </div>
        <div>
          <RhCard>
            <HorizontalContent
              left={<H2>Past Notifications</H2>}
              // right={<RhInput icon={FiSearch} placeholder="Search" />}
            />
            <NotificationList>
              {_.isEmpty(props.pastNotifications) ? (
                <div>No past notifications</div>
              ) : (
                props.pastNotifications.map((notification, index) => (
                  <RhCardListItem
                    key={notification.id}
                    title={notification.title}
                    description={notification.content || ''}
                    startTime={notification.notifyDateTime.toString()}
                    isThumbnailDisabled={true}
                    topRightActions={[
                      <Can
                        key="delete"
                        role={roles?.[0]}
                        perform="delete:notifications"
                        yes={
                          <RhButton
                            mode={RhButtonMode.subtle}
                            prefixSvg={TrashSvg}
                            iconColor={colors.grey}
                            disabled={props.indexBeingDeleted === index}
                            onClick={() => {
                              props.userClickedDeleteOnACard({
                                id: notification.id,
                                type: 'past',
                                index,
                              });
                            }}
                          />
                        }
                      />,
                    ]}
                  />
                ))
              )}
            </NotificationList>
          </RhCard>
        </div>
      </Grid>
      {/* New Notification Form Modal */}
      <RhModal
        isOpen={props.isFormModalOpen}
        onRequestClose={props.userToggledFormModal}
        contentStyle={{ minWidth: 520, width: '25%' }}>
        <HorizontalContent
          left={<H3>New Notification</H3>}
          right={[props.isModalLoading && <CircleSpinner size={15} color={colors.primary} />]}
        />
        <div>
          <SizedBox height={12} />
          <RhTextArea
            placeholder="Title"
            mode={RhInputMode.subtle}
            value={props.formState.title}
            onChange={e => {
              props.userUpdatedFormState(previousFormState => ({
                ...previousFormState,
                title: e.target.value,
              }));
            }}
          />
          <SizedBox height={14} />
          <RhTextArea
            placeholder="Notification"
            mode={RhInputMode.subtle}
            value={props.formState.content}
            onChange={e => {
              props.userUpdatedFormState(previousFormState => ({
                ...previousFormState,
                content: e.target.value,
              }));
            }}
          />
          {/*<SizedBox height={14} />*/}
          {/*<RhCard mode="tiled">*/}
          {/*  <HorizontalContent*/}
          {/*    left={<H2>Thumbnail</H2>}*/}
          {/*    right={[*/}
          {/*      <input*/}
          {/*        key="image-input"*/}
          {/*        type="file"*/}
          {/*        hidden={true}*/}
          {/*        accept="image/*"*/}
          {/*        multiple={false}*/}
          {/*        ref={imageRef}*/}
          {/*        onChange={e => {*/}
          {/*          const file = e.target.files?.[0];*/}
          {/*          if (!file) return;*/}
          {/*          props.userUpdatedFormState(previousFormState => ({*/}
          {/*            ...previousFormState,*/}
          {/*            thumbnail: file,*/}
          {/*          }));*/}
          {/*        }}*/}
          {/*      />,*/}
          {/*      <RhButton*/}
          {/*        key="add-image-button"*/}
          {/*        mode={RhButtonMode.subtle}*/}
          {/*        prefixIcon={FiPlus}*/}
          {/*        iconSize={18}*/}
          {/*        onClick={() => {*/}
          {/*          imageRef.current?.click();*/}
          {/*        }}*/}
          {/*      />,*/}
          {/*    ]}*/}
          {/*  />*/}
          {/*  {props.formState.thumbnail && (*/}
          {/*    <RhImage*/}
          {/*      style={{ aspectRatio: '16 / 9' }}*/}
          {/*      mode="full"*/}
          {/*      src={URL.createObjectURL(props.formState.thumbnail)}*/}
          {/*    />*/}
          {/*  )}*/}
          {/*</RhCard>*/}
          <SizedBox height={20} />
          <SchedulingGrid>
            <RhCard>
              <H2>Date</H2>
              <SizedBox height={12} />
              <DateInputDiv>
                <CalendarSvg width={20} height={20} />
                <DatePicker
                  popperPlacement="top"
                  showPopperArrow={false}
                  selected={props.formState.date}
                  onChange={(date: Date) => {
                    props.userUpdatedFormState(previousFormState => ({
                      ...previousFormState,
                      date,
                    }));
                  }}
                  customInput={<CustomDateInput />}
                  dateFormat="MMMM dd, yyyy, EEE"
                  minDate={new Date()}
                />
              </DateInputDiv>
            </RhCard>
            <RhCard>
              <H2>Time</H2>
              <SizedBox height={12} />
              <DateInputDiv>
                <ClockSvg width={20} height={20} />
                <DatePicker
                  popperPlacement="top"
                  showPopperArrow={false}
                  disabled={!props.formState.date}
                  selected={props.formState.time}
                  onChange={(date: Date) => {
                    props.userUpdatedFormState(previousFormState => ({
                      ...previousFormState,
                      time: date,
                    }));
                  }}
                  showTimeSelect
                  showTimeSelectOnly
                  customInput={<CustomDateInput />}
                  dateFormat="hh:mm aa"
                  timeIntervals={15}
                  filterTime={time => {
                    const dateNow = new Date();
                    const currentDate = new Date(time);
                    const selectedDate = props.formState.date!;

                    // If the [selectedDate] is today, filter out passed time
                    if (selectedDate.toDateString() === dateNow.toDateString()) {
                      selectedDate.setHours(dateNow.getHours());
                      selectedDate.setMinutes(dateNow.getMinutes());

                      return currentDate.getTime() > selectedDate.getTime();
                    } else {
                      return true;
                    }
                  }}
                />
              </DateInputDiv>
            </RhCard>
          </SchedulingGrid>
        </div>
        <ModalFooter>
          <SizedBox height={36} />
          <RhButton
            mode={RhButtonMode.text}
            title="Cancel"
            textStyle={{ fontWeight: 'lighter' }}
            onClick={props.userToggledFormModal}
            disabled={props.isModalLoading}
          />
          <RhButton
            mode={RhButtonMode.text}
            title="OK"
            textStyle={{ fontWeight: 'bold' }}
            onClick={props.userClickedOKOnFormModal}
            disabled={props.isModalLoading || !props.isFormFilled}
          />
        </ModalFooter>
      </RhModal>
    </DashboardWrapper>
  );
};

/** Custom date input component for react-datepicker */
const CustomDateInput = forwardRef((props: any, ref: any) => {
  return (
    <div ref={ref}>
      <RhButton
        disabled={props.disabled}
        mode={RhButtonMode.subtle}
        suffixIcon={FiChevronDown}
        onClick={props.onClick}
        title={props.value || 'Select'}
      />
    </div>
  );
});

const Grid = styled.div`
  display: grid;
  grid-template-columns: 3fr 2fr;
  grid-gap: 20px;
`;

const NotificationList = styled.div`
  margin-top: 14px;
  & > :not(:last-child) {
    margin-bottom: 16px;
  }
`;

const DateInputDiv = styled.div`
  display: flex;
  align-items: center;
  & > :not(:last-child) {
    margin-right: 16px;
  }
`;

const SchedulingGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-gap: 20px;

  .react-datepicker {
    font-family: 'Nunito', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell',
      'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
    background: #ffffff;
    box-shadow: 0px 0px 5px 1px rgba(0, 0, 0, 0.08);
    border-radius: 10px;
    border: none;
  }
  .react-datepicker__header {
    background: #ffffff;
    border-bottom: none;
  }
  .react-datepicker__current-month {
    font-weight: bold;
    font-size: 16px;
    letter-spacing: 0.035em;
    margin-bottom: 8px;
  }
  .react-datepicker__day-names {
    text-transform: uppercase;
    font-weight: bold;
    font-size: 10px;
    letter-spacing: 0.035em;
  }
  .react-datepicker__day--outside-month {
    color: rgba(0, 0, 0, 0.5);
  }
  .react-datepicker__day--selected {
    background: ${colors.primary};
  }
  .react-datepicker__time-list {
    outline: none;
  }
  .react-datepicker__time-list-item--selected {
    background-color: ${colors.primary} !important;
  }
`;

const ModalFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 24px;
  margin-bottom: -16px;
  & > :not(:last-child) {
    margin-right: 24px;
  }
`;
